<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<form [formGroup]="detalleDocumentoFormGroup" #documentoDetalleForm="ngForm">
	<table>
		<tr>
			<th>Nombre</th>
			<th>Código</th>
			<th>Cantidad</th>
			<th>Total</th>
			<th>Buscar</th>
		</tr>
		<tr>
			<td WIDTH="35%">
				<div class="form-group">
					<div class="row">
						<div class="col-12">
							<input formControlName="nombreItem" type="text" class="form-control" placeholder="Nombre Documento"
							  />

							<!-- <ng-select
                                formControlName="nombreItem"
                                [items]="searchCatalog"
                                [selectOnTab]="true"
                                [loading]="searchLoading"
                                bindLabel="nombre"
                                placeholder="Ingrese nombre"
                                (change)="refreshItemDetail($event)"
                                (search)="searchItem($event,'nombre')"
                                addTagText="Agregar Producto"
                                [addTag]="AddProductByName"
                                notFoundText="Sin resultado"></ng-select> -->
						</div>
					</div>
				</div>
			</td>
			<td WIDTH="20%">
				<div class="form-group">
					<div class="row">
						<div class="col-12">
							<input formControlName="codigo" type="number" class="form-control" placeholder="Código SII"
								 />
							<!-- <ng-select
                                formControlName="codigo"
                                [items]="searchCatalog"
                                [selectOnTab]="true"
                                [loading]="searchLoading"
                                bindLabel="codigoBarra"
                                placeholder="Ingrese código"
                                (change)="refreshItemDetail($event)"
                                (search)="searchItem($event,'codigoBarra')"
                                addTagText="Agregar producto"
                                [addTag]="AddProductByCode"
                                notFoundText="Sin resultado"></ng-select> -->
						</div>
					</div>
				</div>
			</td>

			<td WIDTH="15%">
				<div class="form-group">
					<div class="row">
						<div class="col-12">
							<input type="number" formControlName="cantidad" min="1" class="form-control"/>
						</div>
					</div>
				</div>
			</td>
			<td WIDTH="15%">
				<div class="form-group">
					<div class="row">
						<div class="col-12">
							<input type="number" formControlName="total" class="form-control" />
						</div>
					</div>
				</div>
			</td>
			<td>
				<button class="btn btn-default" (click)="openDocumentsListModal(listaBuscaDocumento)">
					<i class="flaticon-search"></i>
				</button>
			</td>

			<!-- <td>
                <div class="text-right" *ngIf="opciones.tipoMoneda == 'CLP'">
                    
                     <div class="float-right">
                         {{currentProduct.precio | number:'1.0-2':'es'}}
                     </div>
                 </div>
            </td> -->
			<td class="text-right">
				<button
					class="btn btn-success px-3"
					(click)="agregarManual()"
					[ngClass]="{
						disabled: documentoDetalleForm.invalid
					}">
					Agregar
					<!-- <i class="flaticon-add"></i> -->
					<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
				</button>
			</td>
		</tr>
		<tr>
			<th>Descripción</th>
			<th>Descuento</th>
			<th>Recargo</th>
			<th>Exento</th>
		</tr>
		<tr>
			<td>
				<div class="form-group">
					<div class="row">
						<div class="col-12">
							<textarea type="text" class="form-control" name="descripcion" formControlName="descripcion" rows="2" cols="90" placeholder="Descripción"></textarea>
						</div>
					</div>
				</div>
			</td>
			<td>
				<div class="form-group">
					<div class="row">
						<div class="col-12">
							<input type="number" class="form-control" name="descuento" formControlName="descuento"/>

							<div *ngIf="documentoDetalleForm.touched && detalleDocumentoFormGroup.controls.descuento.invalid" class="text-danger">
								<div *ngIf="detalleDocumentoFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
							</div>
						</div>
					</div>
				</div>
			</td>
			<td>
				<div class="form-group">
					<div class="row">
						<div class="col-12">
							<input type="number" class="form-control" name="recargo" formControlName="recargo" />
							<div *ngIf="documentoDetalleForm.touched && detalleDocumentoFormGroup.controls.recargo.invalid" class="text-danger">
								<div *ngIf="detalleDocumentoFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
							</div>
						</div>
					</div>
				</div>
			</td>
			<td class="ml-5">
				<div class="form-group ml-5">
					<div class="row pl-5">
						<div class="col-12">
							<input type="checkbox" class="form-check-input" name="exento" formControlName="exento" />
						</div>
					</div>
				</div>
			</td>
		</tr>
	</table>
</form>

<ng-template #listaBuscaDocumento let-d="dismiss" let-c="close">
	<div class="modal-xl">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Lista de documentos disponibles</div>
				<div class="modal-wizard-desc">Seleccione un documento del receptor para asignar y luego agregar</div>
			</div>
			<!-- <button class="btn btn-success float-right" (click)="openCreateProductModal(createProductModal)" *ngIf="permissions.getPermission('30-60-10').asignado">
            <i class="flaticon-add-circular-button"></i>
            Agregar Producto</button> -->
		</div>
		<div class="headings-elements mt-0">
			<app-search-bar [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [config]="configLocal.barraBusqueda" [filtroDTE]="true" [filtroEstadoSii]="true" [filtroEmisor]="false" [filtroEstadoDte]="true" [nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker" [insideModal]="true" (busqueda)="searchElementsByFilter($event)" [useAccordionMode]="false"></app-search-bar>
		</div>
		<div class="modal-body">
			<ngx-datatable
				*ngIf="documentRows.length > 0"
				#productsTable
				[rows]="documentRows"
				class="material"
				[columnMode]="'flex'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="70"
				fxFlex="auto"
				[externalPaging]="true"
				[count]="pageDocuments.totalElements"
				[offset]="pageDocuments.pageNumber"
				[limit]="pageDocuments.pageSize"
				(page)="setPageDocuments($event)"
				[selectionType]="'checkbox'"
				[selected]="selectedDocuments"
				(selected)="onSelect($event)"
				[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
				<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
					<ng-template ngx-datatable-header-template let-value="value">
						<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[0]" (change)="selectAll($event)" />
					</ng-template>
					<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
						<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
					</ng-template>
				</ngx-datatable-column>
				<!-- <ngx-datatable-column name="tipoDocument" [flexGrow]="2" [sortable]="false" [resizeable]="false">
                <ng-template let-column="column" ngx-datatable-header-template>
                    <span class="text-table-alignment">Código Tipo Dte</span>
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row"><span class="text-table-alignment">{{row.codigoTipoDte?row.codigoTipoDte:"Sin código"}}</span>
                </ng-template>
            </ngx-datatable-column> -->
				<ngx-datatable-column name="tipoDocument" [flexGrow]="6" [sortable]="false" [resizeable]="false">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="text-table-alignment">Tipo Documento</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="text-table-alignment">{{ row.nombreTipoDte ? row.nombreTipoDte : "Sin nombre" }}</span>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="folio" [flexGrow]="3" [sortable]="false" [resizeable]="false">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="">Folio</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="">{{ row.folio }}</span>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="fecha" [flexGrow]="3" [sortable]="false" [resizeable]="false">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="date-table-alignment">Fecha</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="date-table-alignment">{{ row.fecha | date : "dd/MM/yyyy" }}</span></ng-template
					>
				</ngx-datatable-column>
				<ngx-datatable-column name="nombreSucursal" [flexGrow]="3" [sortable]="false" [resizeable]="false">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="">Sucursal</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="">{{ row.nombreSucursal ? row.nombreSucursal : "Otra sucursal" }}</span>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="precio" [flexGrow]="3" [sortable]="false" [resizeable]="false">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="number-table-alignment">Monto</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="number-table-alignment">{{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
					</ng-template>
				</ngx-datatable-column>

				<!-- <ngx-datatable-column name="codigo" [flexGrow]="2" [sortable]="false" [resizeable]="false">
                <ng-template let-column="column" ngx-datatable-header-template>
                    <span class="text-table-alignment">Codigo</span>
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row"><span
                        class="text-table-alignment">{{row.codigoBarra}}</span></ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="exento" [flexGrow]="2" [sortable]="false" [resizeable]="false">
                <ng-template let-column="column" ngx-datatable-header-template>
                    <span class="text-table-alignment">Exento</span>
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row"><span class="text-table-alignment">{{row.exento?"Exento":"Afecto"}}</span>
                </ng-template>
            </ngx-datatable-column> -->
			</ngx-datatable>

			<div *ngIf="documentRows.length == 0">
				<span>No hay documentos en la lista para el receptor seleccionado.</span>
			</div>
		</div>
		<div class="modal-footer">
			<div class="form-group position-relative has-icon-left mb-0">
				<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" (click)="procesarDocumentsADetalles()">
					<i class="la la-paper-plane-o d-lg-none"></i>
					<span class="d-none d-lg-block">Enviar</span>
				</button>
				<button type="button" class="btn btn-secondary ml-3" (click)="c('Cross click')">
					<span class="d-none d-lg-block">Cerrar</span>
				</button>
			</div>
		</div>
	</div>
</ng-template>
